<template>
    <v-card>
        <v-card-media
            class="pt-2 pl-2"
            :src="image"
            height="200px">
        </v-card-media>
        <v-card-text class="p-relative">
            <v-btn
                v-if="editMode || !currentSponsorship.id"
                absolute
                dark
                fab
                top
                right
                @click="openFileChooser"
                color="green">
            <v-icon>file_upload</v-icon>
            <ImageInput ref="imageComp" @imageChange="imageChange"></ImageInput>

            </v-btn>
            <v-layout row wrap>
                <template v-if="!editMode && currentSponsorship.id">
                    <v-flex xs12><strong>Nombre:</strong> {{ currentSponsorship[`name_${lang}`] }}</v-flex>
                    <v-flex xs12><strong>Titulo:</strong> {{ currentSponsorship[`title_${lang}`] }}</v-flex>
                    <v-flex xs12><strong>Descripción:</strong> {{ currentSponsorship[`description_${lang}`] }}</v-flex>
                </template>
                <template v-if="editMode || !currentSponsorship.id">
                    <v-flex xs12>
                        <v-text-field
                            label="Nombre"
                            color="green"
                            v-model="form.name"
                            @input="onFormChange"
                            :rules="rules.required"
                            ref="name"
                            required>
                        </v-text-field>
                    </v-flex>
                    <v-flex xs12>
                        <v-text-field
                            label="Titulo"
                            color="green"
                            v-model="form.title"
                            @input="onFormChange"
                            :rules="rules.required"
                            ref="title"
                            required>
                        </v-text-field>
                    </v-flex>
                    <v-flex xs12>
                        <v-text-field
                            label="Descripción"
                            color="green"
                            v-model="form.description"
                            @input="onFormChange"
                            :rules="rules.required"
                            ref="description"
                            multi-line
                            required>
                        </v-text-field>
                    </v-flex>
                </template>
            </v-layout>
        </v-card-text>
    </v-card>
</template>

<script>
    import ImageInput from '@/components/helpers/ImageInput';
    import { mapGetters } from 'vuex';

    export default {
        name: 'TitleCard',
        props: {
            lang: {
                type: String,
                required: true
            },
            editMode: {
                type: Boolean,
                required: false,
                default: false
            }
        },
        components: {
            ImageInput
        },
        data() {
            return {
                requiredFields: [
                    'name',
                    'title',
                    'description'
                ],
                form: {
                    lang: this.lang,
                    name: '',
                    title: '',
                    description: '',
                    image: null
                },
                rules: {
                    required: [
                        val => {

                            let res = ((val === 0 ? '0' : String(val)) || '').length > 0 || 'Este campo es obligatorio'
                            return res
                        }
                    ]
                },
                image: 'https://images.homedepot-static.com/productImages/fc91cb23-b6db-4d32-b02a-f1ed61dd39a8/svn/folkstone-matte-formica-laminate-sheets-009271258408000-64_400_compressed.jpg',
            }
        },
        computed: {
            ...mapGetters([
                'currentSponsorship'
            ])
        },
        watch: {
            currentSponsorship(newValue, oldValue) {
                
                if ( newValue ) {
                    this.image = newValue[`image_${this.lang}`];
                    this.form.name = newValue[`name_${this.lang}`];
                    this.form.title = newValue[`title_${this.lang}`];
                    this.form.description = newValue[`description_${this.lang}`];
                    this.onFormChange();
                }
            }
        },
        methods: {
            imageChange( img, imgFile ) {

                this.image = img.src;
                this.form.image = imgFile

                this.$emit( 'update', this.form );
            },
            openFileChooser() {
                
                this.$refs.imageComp.open();
            },
            onFormChange( menu = null ) {

                if ( menu ) { this[ menu ] = false; }

                this.$emit( 'update', this.form );
            },
            hasErrors() {

                let hasError = false;

                this.requiredFields.forEach( key => {

                    hasError = this.form[ key ] === null || this.form[ key ] === '' || hasError;
                    this.$refs[ key ].validate( true );
                });

                return hasError;
            }
        }

    }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/pages/sponsorships/titleCard.vue